import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createOnboarding,
  getOnboarding,
  updateOnboarding,
} from "controller/api";
import { ApiErrorType } from "shared";
import { sentryLogger } from "utilz";

export const useCreateOnboarding = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createOnboarding,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["onboarding"]);
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "onboarding",
        functionName: "createOnboarding",
      });
    },
  });
};

export const useUpdateOnboarding = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateOnboarding,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["onboarding"]);
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "onboarding",
        functionName: "updateOnboarding",
      });
    },
  });
};

export const useGetOnboarding = () => {
  return useQuery({
    queryKey: ["onboarding"],
    queryFn: () => getOnboarding(),
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "onboarding",
        functionName: "getOnboarding",
      });
    },
  });
};
